import { MessageSquare } from "lucide-react";
export default function HeroContacto() {
  return <section data-section-id="REEMPLAZAR" id="hero-contacto" className="bg-background text-foreground relative overflow-hidden py-20 md:py-28">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,hsl(var(--primary)/0.05)_0%,transparent_70%)] pointer-events-none" />
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 mb-6">
            <MessageSquare className="size-4 text-primary" />
            <span className="text-xs font-mono uppercase tracking-wider text-primary">
              Contacto
            </span>
          </div>
          <h1 className="font-default text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter text-white">
            Hablemos de tu <span className="text-primary font-mono">cumplimiento</span>
          </h1>
          <p className="mt-6 text-lg md:text-xl text-slate-400 font-default leading-relaxed">
            ¿Tienes dudas sobre la LFPIORPI, necesitas una cotización Enterprise o quieres saber si Notalia se ajusta a tu giro? Escríbenos y un asesor te responde a la brevedad.
          </p>
        </div>
      </div>
    </section>;
}